export default defineNuxtPlugin(({ $serverLog, $apiDrive }) => {

  $apiDrive.setResponseInterceptor((response) => {
    return response;
  }, (error) => {
    if (process.server) {
      if (error && error.response && error.response.status && (error.response.status === 404 || error.response.status === 429)) {
        return Promise.reject(error);
      }
      $serverLog.error($serverLog.formatError(error));
    } else {
      /* eslint-disable */
      if (error && error.response && error.response.status && [429, 403].includes(error.response.status)) {
        const status = error.response.status;
        const modified = {
          ...error
        }
        modified.response.data = modified.response.data || {};
        modified.response.data.message = status === 403 ? "Vous avez dépassé le nombre de tentatives erronées autorisées, veuillez réessayer dans une heure." : "Vous avez dépassé le nombre de tentatives autorisées, veuillez réessayer dans quelques instants.";
        return Promise.reject(modified);
      }
    }
    return Promise.reject(error);
  });

})